import { gql } from "@apollo/client";
import { Box } from "@mui/material";
import WithTooltip from "atoms/WithTooltip";
import { COLOR_REACTION, getStatColor } from "helpers/colors";
import React, { useState } from "react";

export const TimelineMarkerFragment = gql`
  fragment TimelineMarkerFragment on Event {
    humanName
    reactionType
  }
`;

export default function TimelineMarker({ event, ...others }) {
  const eventColor = event?.reactionType ? COLOR_REACTION : getStatColor(event?.humanName);
  const [hovering, hoveringSet] = useState(false);
  return (
    <WithTooltip tooltip={event?.humanName} {...others}>
      <Box
        onMouseEnter={() => hoveringSet(true)}
        onMouseLeave={() => hoveringSet(false)}
        sx={{
          width: 3,
          height: 16,
          bgcolor: eventColor,
          borderRadius: 1,
          ...(hovering && {
            opacity: 0.8,
            width: 5,
          }),
        }}
        {...others}
      />
    </WithTooltip>
  );
}
